import { marketingAdministratorRoles } from "../../config/roles";
import { SetRecordState } from "../../api/recordService";
import { isFailedResponse } from "../../api/request";
import { RelatedTableActions } from "../relatedTableActions.types";

const InactiveStateCode = 1;

export const campaignRelatedTableActions: Record<string, RelatedTableActions> = {
  g4c_communication: {
    roles: marketingAdministratorRoles,
    // The same deactivation the communications list offers.
    remove: {
      label: (row) => `Deactivate ${row.name || "communication"}`,
      confirmation: (row) => ({
        title: "Confirm Deactivation",
        confirmText: "Deactivate",
        message: `Are you sure you want to deactivate the ${
          row.name || "communication"
        } record?  You can reactivate it later, if you wish.`,
      }),
      remove: async (globalDispatch, parentId, row) => {
        const response = await SetRecordState(globalDispatch, {
          Ids: [row.id],
          EntityName: "g4c_communication",
          StateCode: InactiveStateCode,
        });

        return !isFailedResponse(response);
      },
    },
  },
};
